import './index.scss'
$("#nav7").addClass("active");